angular.module('hj.customCursor', []).directive('hjCustomCursor', function() {
    'use strict';
    return {
        restrict: 'A',
        link: function($scope, $element, $attr) {

            var x;

            $element.on('mousemove', function(event) {
                event.stopPropagation();

                // if (event.x || event.offsetX < $element[0].clientWidth * 0.5) {
                if (event.pageX < event.view.innerWidth * 0.5) { // hack to allow images to be dragged off

                    $scope.$cursorLeft = true;
                    $scope.$cursorRight = false;

                    if (x !== 'left') {
                        $scope.$apply();
                    }

                    x = 'left';

                } else {
                    $scope.$cursorRight = true;
                    $scope.$cursorLeft = false;

                    if (x !== 'right') {
                        $scope.$apply();
                    }

                    x = 'right';
                }
            });

        }
    };
});
